<template>
  <ModalDefault modal_id="editPlanModal"
                header="y"
                size="modal-md modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_725')"
                :footer="(channels.plan_edit.email !== null && channels.plan_edit.status === 1) || channels.plan_edit.status === 2 || channels.plan_edit.status === 4"
                icon="bx bx-edit mr-1">
    <div class="px-2 py-0" slot="body">
    <!--
      ### Statuses
      1 - Enviar código de verificação
      2 - Inserir o código enviado
      3 - Mensagem de liberação da edição (muda cor e texto do botão para "Salvar alterações de plano")
      4 - Mensagem de bloqueio da edição (volta para o status 1 - "Enviar código de verificação")
    -->
      <div>
        <div class=" d-flex">
          <div v-if="channels.plan_edit.status === 1" class="row animated--grow-in">
            <div class="col-12">
              <label class="mb-0">{{ getTranslations('expression_726') }}</label>
              <div class="input-group mb-4">
                <select v-model="channels.plan_edit.email"
                        class="input_forms custom-select pl-50"
                        style="min-width: 200px;">
                  <option :value="null" disabled>{{ getTranslations('expression_727') }}</option>
                  <option v-for="(email, index) in configs.data.email_authorized"
                          :key="index"
                          :value="email">
                    {{ email.name }} ({{ email.email }})
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div v-if="channels.plan_edit.status === 2" class="row animated--grow-in">
            <div class="col-12">
              <label class="mb-0">{{ getTranslations('expression_728') }}</label>
              <div class="input-group mb-4">
                <input type="password" maxlength="4" v-model="code" class="input_forms form-control">
              </div>
            </div>
          </div>
          <div v-if="channels.plan_edit.status === 3" class="row animated--grow-in">
            <div class="col-12 py-4 text-center">
              <div>
                <i class="bx bx-check-circle text-success" style="font-size: 40px;"></i>
              </div>
              <div>
                <h5>{{ getTranslations('expression_729') }}</h5>
              </div>
            </div>
          </div>
          <div v-if="channels.plan_edit.status === 4" class="row animated--grow-in">
            <div class="col-12 py-4 text-center">
              <div>
                <i class="bx bx-block text-danger" style="font-size: 40px;"></i>
              </div>
              <div>
                <h5>{{ getTranslations('expression_730') }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div v-if="channels.plan_edit.email !== null && channels.plan_edit.email !== '' && channels.plan_edit.status === 1">
        <span @click.prevent="setStatus(2); sendCode()" class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
          <span class="">{{ getTranslations('expression_731') }}</span>
        </span>
      </div>
      <div v-if="channels.plan_edit.status === 2 || channels.plan_edit.status === 4" class="pr-2">
        <span @click.prevent="setStatus(1); code = null" class="shadow-sm cursor_pointer animated--grow-in btn-outline-secondary py-2 px-3">
          <span class="">{{ getTranslations('expression_732') }}</span>
        </span>
      </div>
      <div v-if="channels.plan_edit.status === 2 && code !== null && code !== ''">
        <span @click.prevent="validateCode" class="shadow-sm cursor_pointer animated--grow-in btn-success text-white py-2 px-3">
          <span class="">{{ getTranslations('expression_733') }}</span>
        </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";

export default {
  name: "ModalEditPlan",
  components: {
    ModalDefault
  },
  data(){
    return {
      code: null,
    }
  },
  mounted() {
    // $('#editPlanModal').on('hidden.bs.modal', () => {
    //   if(this.channels.plan_edit.status !== 3) {
    //     this.channels.plan_edit = {
    //       // status: 1,
    //       email: null,
    //       code: null
    //     }
    //   }
    // })
  },
  computed: {
    ...mapState(['channels', 'configs']),
    ...mapGetters([])
  },
  methods: {
    setStatus(payload){
      this.channels.plan_edit.status = parseInt(payload)
    },
    sendCode(){
      const key = Math.floor(Math.random() * 9999).toString();
      const key_formatted = key.length < 4 ? String(key).padStart(4, '0') : key
      this.channels.plan_edit.code = btoa(key_formatted)
      window.localStorage.setItem("token", this.channels.plan_edit.code)
      this.channels.plan_edit.type = "Plano"
      this.$store.dispatch('getAuthorized', this.channels.plan_edit)
    },
    validateCode(){
      if (btoa(this.code) === window.localStorage.getItem("token"))
      {
        this.channels.plan_edit.status = parseInt(3)
      } else {
        this.channels.plan_edit.status = parseInt(4)
      }
      this.code = null
      this.channels.plan_edit.email = null
      this.channels.plan_edit.code = null
      window.localStorage.removeItem("token")
    },
  }
}
</script>

<style scoped>

</style>
